export const GET_PLAN = '@CHANGE_PLAN/GET_PLAN'
export const CHANGE_TO_TEAM_PLAN = '@CHANGE_PLAN/CHANGE_TO_TEAM_PLAN'
export const CHANGE_TO_REGISTER_PLAN = '@CHANGE_PLAN/CHANGE_TO_REGISTER_PLAN'
export const CHANGE_TO_BASIC = '@CHANGE_PLAN/CHANGE_TO_BASIC'
